/**
 * useParams -- Extract route parameters from the nearest matching Route.
 */
import { useContext } from "react";
import { RouterContext } from "./Router";

export function useParams<
  T extends Record<string, string> = Record<string, string>,
>(): T {
  const ctx = useContext(RouterContext);
  return ctx.params as T;
}
